//Refactored for node upgrade

import { PublicClientApplication } from '@azure/msal-browser';
import { MsalProvider } from '@azure/msal-react';
import { LayoutProvider } from '@celito.clients/context';
import {
  RecordNavigationProvider,
  ToastProvider,
} from '@celito.clients/provider';
import { logger } from '@celito.clients/services';
import {
  CustomRouter,
  ErrorOrUnauthorized,
  Loader,
} from '@celito.clients/shared';
import { MsalInstanceManager } from '@celito.clients/singleton';
import { lightTheme, ThemeProvider } from '@celito.clients/theme';
import { history } from '@celito.clients/utils';
import { FluentProvider } from '@fluentui/react-components';
import queryClient from 'libs/core/src/config/query-client';
import { useEffect, useState } from 'react';
import * as ReactDOM from 'react-dom/client';
import { QueryClientProvider } from 'react-query';

import App from './app/app';

/* catch preload event */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
window.addEventListener('vite:preloadError', (event: any) => {
  logger.error(event?.payload ?? 'Dynamic import failed');
  window.location.reload();
});

const root = ReactDOM.createRoot(document.getElementById('root')!);

const Main = () => {
  const [msalInstance, setMsalInstance] =
    useState<PublicClientApplication | null>(null);
  const [error, setError] = useState<Error | null>(null);

  useEffect(() => {
    const init = async () => {
      try {
        const msalManager = MsalInstanceManager.getInstance();
        await msalManager.initMsal();
        const instance = msalManager.getMsalInstance();
        setMsalInstance(instance);
      } catch (err) {
        logger.error(err as Error, {
          origin: 'MSAL Bootstrap Error',
        });
        setError(err as Error);
      }
    };

    init();
  }, []);

  if (error || !msalInstance) {
    return (
      <FluentProvider theme={lightTheme}>
        <ThemeProvider>
          <div
            style={{ display: 'grid', placeContent: 'center', height: '100vh' }}
          >
            {error ? (
              <ErrorOrUnauthorized error={error} />
            ) : (
              <Loader withLabel />
            )}
          </div>
        </ThemeProvider>
      </FluentProvider>
    );
  }

  return (
    <MsalProvider instance={msalInstance}>
      <QueryClientProvider client={queryClient}>
        <CustomRouter history={history}>
          <FluentProvider theme={lightTheme}>
            <ThemeProvider>
              <ToastProvider>
                <LayoutProvider>
                  <RecordNavigationProvider>
                    <App />
                  </RecordNavigationProvider>
                </LayoutProvider>
              </ToastProvider>
            </ThemeProvider>
          </FluentProvider>
        </CustomRouter>
      </QueryClientProvider>
    </MsalProvider>
  );
};

root.render(<Main />);
